module.exports = __webpack_public_path__ + "static/media/7.16a5d2a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/7.wav
// module id = zXM7
// module chunks = 0